import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-student-course-equalization-return',
    templateUrl: './student-course-equalization-return.component.html'
})
export class StudentCourseEqualizationReturnComponent {
    constructor(
        private activeModal: NgbActiveModal
    ) { }

    comment: string;

    ok() {
        this.activeModal.close({
            comment: this.comment
        });
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
